import React from 'react';
import { Toaster } from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../../context/ThemeContext';

export default function ThemedToaster() {
  const { i18n } = useTranslation();
  const { theme } = useTheme();
  const dark = theme === 'dark';
  const rtl = i18n.language === 'ar';
  return (
    <Toaster
      position={rtl ? 'top-left' : 'top-right'}
      toastOptions={{
        style: {
          background: dark ? '#1e293b' : '#ffffff',
          color: dark ? '#f1f5f9' : '#0f172a',
          border: `1px solid ${dark ? '#334155' : '#e5e7eb'}`,
          direction: rtl ? 'rtl' : 'ltr',
          fontSize: '14px',
        },
        success: {
          iconTheme: { primary: dark ? '#22d3ee' : '#0891b2', secondary: dark ? '#0f172a' : '#ffffff' },
        },
        error: {
          iconTheme: { primary: '#ef4444', secondary: '#ffffff' },
        },
      }}
    />
  );
}
